import React, { useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

import { useMediaPredicate } from 'react-media-hook';

import { viewport } from './common/config';
import useMediaStore from './common/store/useMediaStore';

const Root = () => {
  /**
   * Setup MediaStore
   */
  const set = useMediaStore(useCallback(state => state.set, []));
  const setMedia = useMediaStore(useCallback(state => state.setMedia, []));

  const sm = useMediaPredicate(`(min-width: ${viewport.sm})`);
  const md = useMediaPredicate(`(min-width: ${viewport.md})`);
  const lg = useMediaPredicate(`(min-width: ${viewport.lg})`);
  const xl = useMediaPredicate(`(min-width: ${viewport.xl})`);

  useEffect(() => {
    set(sm, md, lg, xl);

    if (xl) setMedia("xl");
    else if (lg) setMedia("lg");
    else if (md) setMedia("md");
    else if (sm) setMedia("sm");
    else setMedia("xs");
  }, [sm, md, lg, xl]);

  /**
   * Setup ViewportStore
   */
  // const setHeight = useViewportStore(useCallback(state => state.setHeight, []));
  // const setWidth = useViewportStore(useCallback(state => state.setWidth, []));

  // const [ref, { width, height }] = useMeasure();

  // useEffect(() => setHeight(height), [height]);
  // useEffect(() => setWidth(width), [width]);

  /**
   * Render
   */
  return <App />;
}


ReactDOM.render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
